export default {
    // ========== Acciones con evaluaciones ==========
    replicateEvaluationTo: 'Replicar la {entity} a otras {sections}',

    // ========== Mensajes de replicación ==========
    replicatedEvaluations: '{entity} Replicados',
    replicatedEvaluationsFeminine: '{entity} Replicadas',
    evaluationsReplicatedInSections: 'Las {entity} fueron replicados en las siguientes secciones:',
    evaluationUpdatedInSection: 'La {entity} fue actualizada en la siguiente sección:',
    instrumentsReplicatedInEvaluations: 'Los {entity} fueron replicados en las siguientes evaluaciones:',
    recreated: 'Recreada',
    selectSectionsToUpdate: 'Seleccione las {entity} a donde se van a actualizar:',
    selectSectionsToReplicate: 'Seleccione las {entity} a donde se van a replicar:',
    selectEvaluationsToReplicate: 'Seleccione las evaluaciones a donde se van a replicar:',
    selectOneOrMoreToFilter: 'Seleccione uno o varios para filtrar.',

    // ========== Tooltips y mensajes informativos ==========
    additionalInformationOf: 'Información adicional de {entity}',
    notAvailable: 'no disponible',
    closed2: 'cerrado',
    closed3: 'cerrada',
    closedParentheses: '(Cerrada)',
    removeOption: 'Quitar opción',
    toOtherEvaluations: 'a las otras Evaluaciones',
    pressToViewColorMeaning: 'Presione para poder visualizar el significado de los colores en las {entity}.',
    colorInformationFor: 'Información de los colores para la {entity}.',
    goToEntity: 'Ir a la {entity}',
    lockEntity: 'Bloquear {entity}',
    unlockEntity: 'Desbloquear {entity}',
    isClosedEntity: 'Se encuentra cerrado {entity}',
    viewAsStudent: 'Ver como Estudiante',
    viewAsTeacher: 'Ver como Profesor',
    assignedScore: 'Puntaje asignado',
    teacherInstructions: 'Instrucciones para el Docente',
    studentInstructions: 'Instrucciones para el Estudiante',
    teacherFormat: 'Formato para el Docente',
    studentFormat: 'Formato para el Estudiante',
    instructionsAndGuidelineTeacher: 'Instrucciones y Pauta para el Docente',
    instructionsAndGuidelineStudent: 'Instrucciones y Pauta para el Estudiante',
    rubric: 'Rúbrica',
    answerKeys: 'Claves de Respuesta',
    noInstrumentCreated: 'No hay ningún {entity} creado.',
    toCreateNewInstrument: 'Para crear un nuevo {entity} seleccione el botón "Agregar {entity}".',
    noInstrumentAvailableForEvaluatee: 'No hay {entity} disponibles para responder en este momento.',
    noInstrumentAvailableForEvaluator: 'No hay {entity} disponibles para corregir en este momento.',

    // ========== Confirmaciones y alertas ==========
    confirmationRequired: 'Confirmación Necesaria',
    sureCloseUnsavedData: '¿Estás seguro de que quieres cerrar? Los datos no guardados se perderán.',
    yesClose: 'Sí, cerrar',
    accessDenied: 'Acceso Denegado',
    noPermissionForAction: 'No tienes permiso para realizar esta acción',
    all: '-- TODOS --',

    // ========== Descripciones de colores ==========
    indicatesNotExistsCanReplicate: 'Indica que no existe, por lo que se puede se puede replicar de forma directa.',
    indicatesExistsCannotReplicate: 'Señala que existe, por lo que no se puede replicar de forma directa, manejar a través de los {entity}.',

    // ========== Impresión ==========
    fullEvaluationPrint: 'Impresión completa de la evaluación',

    // ========== Títulos de modales ==========
    updateEvaluationInCreatedSections: 'Actualizar la {entity} en las {sections} creadas',
    replicateEvaluation: 'Replicar la {entity}',
    replicateEvaluationInOtherSections: 'Replicar la {entity} en las otras {sections} de la {subject}',
    selectFiles: 'Seleccionar Archivos',

    // ========== Header evaluation ==========
    type: 'Tipo',
    weighting: 'Ponderación',
    weightingMustBe100: 'La ponderación debe ser 100%',
    sumWeightingsMustBe100: 'La suma de ponderaciones debe ser 100%',
    noStartDate: 'No cuenta con Fecha de Inicio',
    noEntityForEntity: 'No hay {entity1} para esta {entity2}',
    replicateInstrumentInOtherEvaluations: 'Replicar {entity} en otras evaluaciones',
    sureToDeleteEntityAndInstruments: '¿Está seguro de que desea eliminar la {entity} y sus instrumentos creados?',
    wasDeletedThe: 'Se eliminó la',
    wasDeletedTheMale: 'Se eliminó el',
    createdBy: 'Creado por',
    creationDate: 'Fecha de Creación',
    attachedFiles: 'Archivos Adjuntos',
    addAttachedFile: 'Agregar Archivo Adjunto',

    // ========== Header output format ==========
    acronym: 'Sigla',
    subjectName: 'Nombre Asignatura',
    assignedTime: 'Tiempo Asignado',
    percentageWeighting: '% Ponderación',
    hours: 'Horas',

    // ========== View evaluation grade ==========
    grade: 'Nota',
    obtainedGrade: 'Nota Obtenida',
    obtained: 'Obtenida',
    assigned: 'Asignada',
    automatic: 'Automática',
    useAutomaticGrade: 'Utilizar nota automática',
    gradeUpdated: 'Nota actualizada.',

    // ========== Evaluatee carousel ==========
    currentlyEvaluating: 'Actualmente evaluando a',
    selectStudent: 'Seleccionar Estudiante',
    sortByFirstName: 'Ordenar por Nombre',
    sortByLastName: 'Ordenar por Apellido',
    pressToViewIconLegend: 'Presione para poder visualizar la Leyenda de Iconos del Evaluado',
    evaluateeIconLegend: 'Leyenda de Iconos del Evaluado',
    information: 'Información',
    icon: 'Icono',
    evaluateeStartedEvaluation: 'Evaluado que ya inició su {entity}',
    evaluateeStartedButNotFinished: 'Evaluado que comenzó la {entity} pero no la finalizó',
    evaluateeFinishedEvaluation: 'Evaluado que ya terminó su {entity}',
    evaluateeNotStarted: 'Evaluado que aún no ha empezado su {entity}',
    evaluateeGradePublished: 'Evaluado que ya se le publicó su nota/puntaje',
    groupLeader: 'Lider de Grupo',
    previousUncorrected: 'Anterior sin corregir',
    goToPrevious: 'Ir al anterior',
    goToNext: 'Ir al siguiente',
    nextUncorrected: 'Siguiente sin corregir',
    noStudentsSelected: 'No hay estudiantes seleccionados.',

    // ========== New evaluation form ==========
    step1DetailsOf: 'Paso 1: Detalles de la {entity}',
    step1DetailsOf2: 'Paso 1: Detalles del {entity}',
    step2AssignEvaluatees: 'Paso 2: Asignar Evaluado(s)',
    step3AssignEvaluators: 'Paso 3: Asignar Evaluador(es)',
    title: 'Título',
    randomQuestions: 'Preguntas Aleatorias',
    randomQuestionsTooltip: 'Esta opción le permite al Estudiante visualizar las preguntas del {entity} de forma aleatorias.',
    randomAlternatives: 'Alternativas Aleatorias',
    randomAlternativesTooltip: 'Esta opción le permite al Estudiante visualizar las alternativas de las preguntas de selección del {entity} de forma aleatoria.',
    evaluativeAgent: 'Agente Evaluativo',
    allowAutoEvaluate: 'Permitir realizar Autoevaluación',
    allowAutoEvaluateTooltip: 'Esta opción le permite al Evaluado responder la rúbrica.',
    requiredGreaterOrEqualZero: 'Este campo es obligatorio, debe ser mayor o igual que 0',
    andCannotExceed: 'y no puede superar {value}%.',
    workType: 'Tipo de Trabajo:',
    workTypeLabel: 'Tipo de Trabajo',
    examiner: 'Examinador:',
    allowModifyDates: 'Permitir modificación de las fechas',
    allowModifyDatesTooltip: 'Esta opción permite la modificación de las fechas a los Docentes',
    defineStartDate: 'Definir fecha de inicio',
    mustEnterValidStartDate: 'Debe ingresar una fecha de inicio válida.',
    startTime: 'Hora de Inicio',
    defineStartTime: 'Definir hora de inicio',
    mustEnterStartTime: 'Debe ingresar la hora de inicio.',
    nameOf: 'Nombre de la {entity}',
    descriptionOf: 'Descripción de la {entity}',
    editDescriptionOf: 'Editar Descripción de la {entity}',
    editDescriptionOf2: 'Editar Descripción del {entity}',
    evaluationType: 'Tipo de Evaluación',
    weightingOf: 'Ponderación de la {entity}',
    requiredAndGreaterThanZero: 'Este campo es obligatorio y debe ser mayor a 0.',
    category: 'Categoría',
    selectFile: 'Seleccionar Archivo',
    files: 'Archivos',
    formFieldsDisabled: 'Los campos de este formulario se encuentran deshablitidados y para poder editarlos diríjase al {entity}.',
    mustBeGreaterThanZeroAnd: 'Debe ser mayor que 0 y',
    requiredFieldAnd: 'Este campo es obligatorio y',
    mustNotExceed: 'No debe exceder a',
    previousStep: 'Paso anterior',
    nextStep: 'Siguiente paso',
    lockCreationOf: 'Bloquear creación de {entity}',
    createdSuccessfully: 'Se creó la {entity}',
    editedSuccessfully: '{entity} editada correctamente',

    // ========== Tabla de especificaciones ==========
    specificationTable: 'Tabla de Especificaciones',
    learningOutcome: 'Resultado de Aprendizaje',
    achievementIndicator: 'Indicador de Logro',
    achievementIndicatorWeighting: 'Ponderación Indicador de Logro',
    evaluationIndicatorWeighting: 'Ponderación Indicador de Evaluación',
    questionOrItemNumber: 'N° de Pregunta o Ítems',
    toAddEntityMustCreateEntity: 'Para agregar una {entity1} debe crear una {entity2}',
    sumWeightingGreaterThan: 'La suma de las ponderaciones de los (IE) es mayor que la ponderación del (IL)',
    total: 'Total',
    totalWeightingMustEqual100: 'La ponderación total debe ser igual a 100.',
    forTheEvaluation: 'Para la Evaluación',

    // ========== Formulario de rúbrica ==========
    titleOf: 'Título de la {entity}',
    titleOf2: 'Título del {entity}',
    editTitleOf: 'Editar Título de la {entity}',
    optionalField: 'Este campo es opcional.',
    evaluationCriteriaMicro: '{entity1} de la {entity2}',
    showToEvaluatees: 'Mostrar a evaluados',
    ifThisOptionIsSelectedContent: 'Si se selecciona esta opción el contenido estará visible para el Evaluado',
    entityBy: '{entity} por',
    addDescriptorTo: 'Agregar Descriptor a {entity}',
    showCoevaluator: 'Mostrar Coevaluador',
    showsEvaluateeWhoEvaluated: 'Muestra al evaluado quién fue la persona que lo evaluó.',
    coevaluationType: 'Tipo de coevaluación',
    selectMultipleAllowsRepeated: 'Al seleccionar múltiple, permite seleccionar varios coevaluados aunque se repitan en una coevaluación.',
    simpleCoevaluation: 'Coevaluación simple',
    multipleCoevaluation: 'Coevaluación múltiple',
    percentage: 'Porcentaje',
    score: 'Puntaje',
    showDescriptors: 'Mostrar Descriptores',
    hideDescriptors: 'Ocultar Descriptores',
    selectMethod: 'Seleccione el método:',
    congruentSelfEvaluationMethod: 'Método de autoevaluación congruente (Mac)',
    gradesDependOnCoincidence: 'La nota depende de la coincidencia de notas del Evaluador y el que se autoevalúa.',
    weightedGradingMethod: 'Método de calificación ponderado',
    percentageIndicatesWeighting: 'El porcentaje indica la ponderación de la calificación que se autoasigna el estudiante, donde 0 es sin relevancia y 100 su máxima.',
    studentWeightingMessage: 'El estudiante posee un peso en la ponderación de {percentage}% en la evaluación, lo que significa que el profesor tiene el {remaining}% restante.',
    fieldMustBeBetween0And100: 'Este campo debe ser un valor entre 0 y 100.',
    fieldMustBePositiveInteger: 'Este campo debe ser un número entero positivo.',
    instrumentTypes: 'Tipos de Instrumentos',
    preview: 'Previsualizar',
    sureToSaveEntityWithMultipleCoevaluated: '¿Está seguro de que desea guardar la {entity} siendo que existen <b>múltiples coevaluados asignados</b>?',
    actionCannotBeRevertedCoevaluatorsReset: '¡Esta acción no se podrá revertir y los coevaluados se restablecerán!',
    evaluateesUnassignedSuccessfully: 'Evaluados Desasignados Satisfactoriamente',
    entityCreated: '{entity} creado.',
    entityEdited: '{entity} editado.',

    // ========== Vista previa de preset de rúbrica ==========
    noAchievementLevelsToShow: 'No hay niveles de logro para mostrar.',
    percentageAchievement: '% Logro',
    achievementLevelsDescription: 'Descripción Niveles de Logro',

    // ========== Formulario de criterios de rúbrica ==========
    availableWeighting: 'Ponderación disponible:',
    fieldMustBeBetween0AndMax: 'Este campo debe ser un valor entre 0 y {max}.',
    fieldMustBe0: 'Este campo debe ser 0',
    fieldMustBeNumberGreaterThan0: 'Este campo debe ser un número mayor a 0.',
    maxTwoDecimals: 'Máximo dos decimales.',
    savingEntity: 'Guardando {entity}...',
    pleaseWaitWhileSavingObject: 'Por favor, espera mientras se guarda el objeto.',
    entityCreatedFeminine: '{entity} creada.',
    entityUpdatedFeminine: '{entity} actualizada.',
    problemSavingEntity: 'Hubo un problema al guardar la {entity}.',
    sureToDeleteEntity: '¿Está seguro de que desea eliminar la {entity}?',
    entityDeletedFeminine: '{entity} eliminada.',

    // ========== Tabla de especificaciones - Input ==========
    changeNotSavedWeightingExceeds100: 'Cambio no guardado dado que la ponderación supera el 100%.',
    weightingUpdated: 'Ponderación actualizada',

    // ========== Header del instrumento ==========
    scoreObtained: 'Puntaje Obtenido',
    feedback: 'Retroalimentación',
    description: 'Descripción',
    attachmentsForTeacher: 'Anexos para el Docente',
    attachmentsForTeacherTooltip: 'Estos Anexos son solo visibles para los Administradores y Docentes.',
    addFile: 'Agregar Archivo',
    attachmentsForStudent: 'Anexos para el Estudiante',
    attachmentsForStudentTooltip: 'Los Estudiantes con acceso a la evaluación podrán ver estos anexos, junto con Administradores y Docentes.',
    scoreOf: 'Puntaje del {entity}',
    currentScoreOfQuestions: 'Puntaje actual de las preguntas',
    questionScoreGreaterThanEntity: 'El puntaje de las preguntas es mayor que el puntaje de la {entity}',
    questionScoreLessThanEntity: 'El puntaje de las preguntas es menor que el puntaje de la {entity}',
    equalizeScoreWithQuestions: 'Igualar Puntaje total con respecto al Puntaje actual de las preguntas',
    reviewStudentView: 'Revisar punto de vista del Estudiante',
    returnToTeacherView: 'Volver al punto de vista del Profesor',
    scoreUpdatedOf: 'Se actualizó el puntaje del {entity}',

    // ========== InfoTest ==========
    readyToClose: 'lista para cerrar.',
    closed: 'cerrada.',
    instrumentIsValid: 'Esta {entity} es válida. Está lista para ser publicada.',
    closingInstrumentAllowsActions: 'Al cerrar la {entity} se podrá cerrar la Asignatura, copiar la {entity} y crear nuevas secciones.',
    pressToCloseInstrument: 'Si desea cerrar la {entity} presione este botón',
    pressToReopenInstrument: 'Si desea volver a abrir la {entity} presione este botón',
    problemsFound: 'Problemas encontrados:',
    pressToViewErrors: 'Presione aquí para visualizar los errores',
    informationOf: 'Información {entity}',
    closeEntity: 'Cerrar {entity}',
    closingWillMakeAvailableToEvaluatees: 'Esto provocará que la {entity} se encuentre disponible para los evaluados',
    closedSuccessfully: 'Se cerró exitosamente la {entity}',
    openEntity: 'Abrir {entity}',
    openingWillMakeUnavailableToEvaluatees: 'Esto provocará que la {entity} ya no esté disponible para los evaluados',
    openedSuccessfully: 'Se abrió exitosamente la {entity}',

    // ========== GroupsContainer ==========
    groups: 'GRUPOS',
    addGroup: 'Agregar Grupo',
    copyGroup: 'Copiar Grupo',
    createGroup: 'Crear Grupo',
    selectEntity: 'Seleccionar {entity}',
    groupsCopied: 'Grupos Copiados',
    groupCopied: 'Grupo Copiado',

    // ========== GroupsForm ==========
    groupName: 'Nombre del Grupo',
    selectGroupMembers: 'Seleccionar Miembros del Grupo',
    studentAlreadyInGroup: 'Este estudiante ya está en un Grupo',
    selectGroupLeader: 'Seleccionar Lider de Grupo',
    selectLeaderOfGroup: 'Seleccione Lider del Grupo',
    noResultsFoundFor: 'No se encontró resultados para',
    groupCreated: 'Se creó el Grupo',
    groupEdited: 'Se editó el Grupo',
    sureToDeleteGroup: '¿Está seguro de que desea eliminar el <b>Grupo</b>?',
    groupDeleted: 'Se eliminó el Grupo',

    // ========== GroupsTable ==========
    groupMembers: 'Miembros del Grupo',
    studentInGroupName: 'Este estudiante está en el Grupo: \'\'{groupName}\'\'',
    editGroup: 'Editar Grupo',
    deleteGroup: 'Eliminar Grupo',
    noGroupsEntered: 'No hay ningún grupo ingresado',
    sureToDeleteTheGroup: '¿Está seguro de que desea eliminar el Grupo?',
    entityDeleted: 'Se eliminó el {entity}',

    // ========== NewSpecificationTable ==========
    byQuestion: 'POR PREGUNTA',
    questions: 'Preguntas',
    addQuestion: 'Agregar Pregunta',
    editQuestion: 'Editar Pregunta',
    editEntity: 'Editar {entity}',
    byCriteria: 'POR CRITERIO',
    byCognitiveLevel: 'POR NIVEL COGNITIVO',
    pressToViewCognitiveLevelColors: 'Presione para poder visualizar los colores de los {entity}.',
    cognitiveLevelInformation: 'Información de los {entity}.',
    createQuestion: 'Crear Pregunta',
    development: 'Desarrollo',
    selection: 'Selección',
    matching: 'Emparejamiento',
    multiple: 'Múltiple',
    simple: 'Simple',
    extensive: 'Extenso',
    brief: 'Breve',

    // ========== NewQuestionForm ==========
    questionTypeLabel: 'Tipo de pregunta',
    questionSubTypeLabel: 'Subtipo de pregunta',
    questionTypeNotBelongToEntity: 'El Tipo de pregunta seleccionado no pertenece a la {entity}.',
    questionSubTypeNotBelongToEntity: 'El Subtipo de pregunta seleccionado no pertenece a la {entity}.',
    scoreExceededBy: 'Se excedió en el puntaje en: {score}, con respecto al IE seleccionado.',
    availableScoreIs: 'Puntaje disponible es de: {score}, correspondiente al IE seleccionado.',
    questionCreated: 'Se creó la Pregunta.',
    questionEdited: 'Se editó la Pregunta.',
    questionDeleted: 'Se eliminó la pregunta',
    questionUpdated: 'Se actualizó la pregunta',
    sureToDeleteQuestion: '¿Está seguro de que desea eliminar la pregunta?',
    questionScoreDoesNotMatchInstrument: '¡El puntaje de las preguntas no coincide con el puntaje máximo del {entity}!',
    shouldInstrumentScoreBeUpdatedAutomatically: '¿Desea que el puntaje del {entity} se actualice automáticamente?',

    // ========== NewCognitiveLevelDimensionsST ==========
    cognitiveLevel: 'Nivel cognitivo',
    quantityOf: 'Cantidad de',

    // ========== NewEvaluationCriterialDimensionsST ==========
    statement: 'Enunciado',
    quantity: 'Cantidad',
    orderNumber: 'N° de orden',

    // ========== NewCognitiveLevelST ==========
    totalScoreOf: 'Puntaje total de',
    questionSubType: 'Sub-tipo de preguntas',
    briefDevelopment: 'Desarrollo breve',
    extensiveDevelopment: 'Desarrollo extenso',
    simpleSelection: 'Selección simple',
    multipleSelection: 'Selección múltiple',
    addedScore: 'Puntaje agregado',
    questionNumber: 'Pregunta N°',

    // ========== CorrectAnswerComponent ==========
    item: 'Ítem',
    key: 'Clave',

    // ========== RubricsContainer ==========
    hideColumns: 'Ocultar columnas',
    number: 'Número',
    points: 'Puntos',
    manualScoreFeedback: 'Puntaje manual / Retroalimentación',
    doesNotHave: 'No tiene',
    feedbackLabel: 'Feedback',
    evaluatedDimension: '{entity} evaluada',
    withoutFeedback: 'Sin retroalimentación',
    created: 'creadas',
    mustBeBetween: 'Debe estar entre {entity1} y {entity2}',
    editFeedback: 'Editar retroalimentación',
    viewEditFeedback: 'Ver/Editar retroalimentación',
    addFeedback: 'Agregar retroalimentación',
    viewFeedback: 'Ver retroalimentación',
    feedbackSaved: 'Retroalimentación guardada',
    manualScoreSaved: 'Puntaje manual guardado',
    invalidScore: 'Puntaje inválido',
    scoreValueRequired: 'Debe ingresar un puntaje válido',
    valueRequired: 'Valor requerido',
    scoreMustBeValidNumber: 'El puntaje debe ser un número válido',
    saveScore: 'Guardar puntaje',
    thisNoCreated: 'No hay {entity} creadas',
    assignEntityToEntity: 'Asignar el {entity1} a la {entity2} completa',
    correspondsToPonderationOf: 'Corresponde a la ponderación de la {entity}',
    updatingScoresOf: 'Actualizando los puntajes de la {entity}...',
    pleaseWaitWhileLoading: 'Por favor, espera mientras carga.',
    entityDoesNotWeigh: 'Este {entity} no pondera',
    sureDeleteEntityFromRubric: '¿Está seguro de que desea eliminar esta instancia de "{entity}" de la rúbrica?',
    sureDeleteRubric: '¿Está seguro de que desea eliminar la rúbrica?',
    rubricDeleted: 'Rúbrica eliminada',
    entityIsUnlockedAndClosed: 'La {entity} se encuentra desbloqueada y cerrada',
    entityIsLockedAndClosed: 'La {entity} se encuentra bloqueada y cerrada',
    selectWhereToApplyCopy: 'Seleccione donde se aplicará la copia',
    copyRubric: 'Copiar rúbrica',
    coevaluation: 'Coevaluación',
    assignStudentsRandomly: 'Asignar estudiantes de forma aleatoria',
    assign: 'Asignar',
    firstNames: 'Nombres',
    lastNames: 'Apellidos',
    coevaluate: 'Coevaluar',
    coevaluator: 'Coevaluador',
    coevaluators: 'Coevaluadores',
    youAreCoevaluating: 'Estás coevaluando',
    oneStudentCount: '1 estudiante',
    studentsCount: '{count} estudiantes',
    evaluated: 'Evaluado',
    missingEvaluation: 'Falta evaluar',
    evaluateesAssignedSuccessfully: 'Evaluados asignados satisfactoriamente',
    evaluateesLeftUnassigned: 'Se asignaron coevaluadores, pero {count} evaluados quedaron sin pareja: están solos en su grupo o sus asignaciones manuales no permiten completar parejas. Asígnelos a mano.',
    evaluateeAssignedSuccessfully: 'Evaluado asignado satisfactoriamente',
    evaluateeRemoved: 'Evaluado eliminado',
    andLessThanOrEqualTo100: 'y menor o igual a 100',
    teacherResponse: 'Respuesta del docente',
    coevaluatorResponse: 'Respuesta del coevaluador',
    evaluateeResponse: 'Respuesta del evaluado',
    descriptorCreated: 'Descriptor creado',
    descriptorUpdated: 'Descriptor actualizado',
    scoreUpdated: 'Puntaje actualizado',

    // ========== EvaluateeTime ==========
    remainingTime: 'Tiempo Restante',
    questionsAnswered: 'Preguntas respondidas',
    finishedWaitingCorrection: '{entity} finalizado (En espera de corrección)',
    corrected: 'Corregido',

    // ========== EvaluatorTestScore ==========
    evaluate: 'Evaluar',
    status: 'Estado',
    notStarted: 'No iniciado',
    startedOn: 'Iniciado el',
    evaluateeAttachments: 'Adjuntos del Evaluado',
    proposedScore: 'Puntaje propuesto',
    maximumScore: 'Puntaje Máximo',
    applyAutomaticScore: 'Aplicar Puntaje Automático',
    noteOf: 'Nota del',
    publish: 'Publicar',
    missingToEvaluate: 'Faltan {count} {entity} por evaluar',
    revertPublication: 'Revertir publicación',
    replicateGradeToGroup: 'Replicar nota al grupo',
    selectEvaluatees: 'Seleccionar Evaluados',
    copyFeedback: 'Copiar Retroalimentación',
    evaluatorAttachment: 'Adjunto del Evaluador',
    attachFile: 'Adjuntar Archivo',
    instrumentScoreUpdated: 'Puntaje de Instrumento actualizado.',
    feedbackUpdated: 'Retroalimentación actualizada.',
    scorePublished: 'Puntaje publicado.',
    gradesReplicated: 'Notas Replicadas',
    evaluatees: 'Evaluados',
    evaluateesSelected: 'Evaluados seleccionados',

    // ========== BodyInstrument ==========
    notAllowedToPrintWhileRunning: '🚫 No está permitido imprimir mientras se ejecuta el {entity}.',
    editTitle: 'Editar título',
    entityUnlockedAndClosed: 'La {entity} se encuentra desbloqueada y cerrada.',
    entityLockedAndClosed: 'La {entity} se encuentra bloqueada y cerrada.',
    writeStatementTitle: 'Redactar enunciado del título',
    sureDeleteEntityAndQuestions: '¿Está seguro de que desea eliminar el {entity} y sus Preguntas?',
    deleteGroup2: 'Eliminar conjunto',
    only: 'Solo',

    // ========== QuestionsContainer ==========
    addQuestionInsideSegment: 'Agregar Pregunta dentro del {entity}',
    question: 'Pregunta',

    // ========== NewQuestionCard ==========
    achievementIndicators: 'Indicadores de Logro',
    noAssociatedIndicator: 'No se ha asociado ningún Indicador de Logro a la Pregunta',
    indicatorAssociatedToQuestion: 'Indicador de Logro asociado a la pregunta',
    indicatorsAssociatedToQuestion: 'Indicadores de Logro asociados a la pregunta',
    questionUnlockedAndClosed: 'La Pregunta se encuentra desbloqueada y cerrada.',
    lockQuestion: 'Bloquear Pregunta',
    questionLockedAndClosed: 'La Pregunta se encuentra bloqueada y cerrada.',
    unlockQuestion: 'Desbloquear Pregunta',
    duplicateQuestion: 'Duplicar Pregunta',
    deleteQuestion: 'Eliminar Pregunta',
    editDescription: 'Editar Descripción',
    scoreGreaterThanInstrument: 'El puntaje de las preguntas es mayor que el puntaje que tiene {entity}',
    scoreLessThanInstrument: 'El puntaje de las preguntas es menor que el puntaje que tiene {entity}',
    questionType: 'Tipo de pregunta',
    questionTypeNotBelongToSituation: 'El Tipo de pregunta no pertenece a la {entity}.',
    questionNotSaved: 'Pregunta no guardada',
    questionSaved: 'Pregunta guardada',
    automaticScore: 'Puntaje Automático',
    scoreCannotBeLessThanZero: 'El puntaje no debe ser menor que 0',
    assignedScoreGreaterThanQuestion: 'El puntaje asignado es mayor que el de la pregunta',
    addCorrectAnswer: 'Añadir Respuesta Correcta',
    addIncorrectAnswer: 'Añadir Respuesta Incorrecta',
    correctAnswer: 'Respuesta Correcta',
    clearCorrectAnswer: 'Limpiar Respuesta Correcta',
    editCorrectAnswer: 'Editar la Respuesta Correcta',
    incorrectAnswer: 'Respuesta Incorrecta',
    clearIncorrectAnswer: 'Limpiar Respuesta Incorrecta',
    editIncorrectAnswer: 'Editar la Respuesta Incorrecta',
    clearFeedback: 'Limpiar Retroalimencación',
    modifyCorrectAnswer: 'Modificar la Respuesta Correcta',
    modifyIncorrectAnswer: 'Modificar la Respuesta Incorrecta',
    modifyFeedback: 'Modificar Retroalimencatión',
    modifyDescription: 'Modificar Descripción',
    exceededWeighting: 'Se excedió del {weighing}% asignado en el IE, aproximadamente en: {score}',
    availableWeighting2: 'Actualmente tiene disponible {weighing}% para el IE seleccionado, en puntaje es: {score}',
    questionScoreUpdated: 'Puntaje de la pregunta actualizado.',
    evaluateeScoreUpdated: 'Puntaje del evaluado actualizado.',
    questionCopied: 'Pregunta duplicada.',
    sureChangeQuestionScore: '¿Está seguro de cambiar el puntaje de la pregunta?',
    changeScoreWhenGradeFixed: 'cuando la nota de la evaluación ya está fijada, o desea cambiar la nota a <strong>automática</strong> para que se recalcule en base a lo que está modificando?',
    imSure: 'Estoy seguro/a',
    keepAssignedGrade: 'Mantener la nota asignada',

    // ========== MatchingQuestion ==========
    term1: 'Término 1',
    term2: 'Término 2',
    selectCorrectOptionsNumber: 'Selecciona el número de opciones correctas',
    optionsNumber: 'N° de Opciones',
    answer: 'Respuesta',
    addAlternative: 'Agregar alternativa',
    alternativeAdded: 'Se agregó una alternativa',

    // ========== MatchingQuestionDraggableOption ==========
    deleteAlternative: 'Eliminar Alternativa',
    addTermsToNextConcept: 'Agregar términos al siguiente concepto',
    clearAlternative: 'Limpiar Alternativa',
    selectAlternative: 'Seleccionar Alternativa',
    maxAssociationsReached: 'Máximo de asociaciones alcanzada para {text}',
    removeSelection: 'Remover Selección',
    sureDeleteAlternative: '¿Está seguro de que desea eliminar la alternativa?',
    alternativeDeleted: 'Se eliminó la alternativa',

    // ========== MatchingQuestionScore ==========
    scoreDistributionTable: 'Tabla de distribución de puntaje',

    // ========== MatchingQuestionScoreInput ==========
    optionsTotalScoreGreaterThanQuestion: 'El puntaje total de las opciones es mayor que el puntaje total de la pregunta',

    // ========== LimitQuestion ==========
    limitAnswerLength: 'Limitar longitud de respuesta',
    limitBy: 'Limitar por',
    setLimit: 'Establecer límite',
    limitAnswerLengthIn: 'Limitar longitud de respuesta en {length} {type}',
    answerTextHere: 'Texto de respuesta aquí',
    answerExceedsTeacherLimit: 'La respuesta supera límite establecido por el Docente',
    answerIsEmpty: 'La respuesta se encuentra vacía',
    answerPasteNotAllowed: 'No está permitido pegar texto en la respuesta',
    showAnswerFormatting: 'Ver formato original del estudiante',
    showAnswerFormattingHelp:
      'La respuesta se muestra como texto simple para que puedas leer todo lo que escribió el estudiante, incluso texto en blanco o en colores muy claros que podría pasar desapercibido. Activa esta opción para verla tal como la escribió, con colores, negritas y listas.',
    savedAnswer: 'Respuesta guardada',

    // ========== SelectQuestionOptions ==========
    toAssignCorrectAnswerMustGiveScore: 'Para poder asignar la respuesta correcta, tiene que darle puntaje a la pregunta',
    correctAlternative: 'Alternativa correcta',
    writeAtLeastOneCharacter: 'Escribe al menos un carácter',
    optionsToSelect: 'Opciones a seleccionar',
    scoreCalculationMethod: 'Método de cálculo de puntaje',
    alternativeModified: 'Se modificó la alternativa',
    answerSaved: 'Respuesta guardada',

    // ========== NewInstrumentForm ==========
    endDate: 'Fecha de Entrega',
    defineEndDate: 'Definir fecha de entrega',
    mustEnterValidEndDate: 'Debe ingresar una fecha de entrega válida.',
    endTime: 'Hora de Entrega',
    defineEndTime: 'Definir hora de entrega',
    mustEnterEndTime: 'Debe ingresar la hora de entrega.',
    visibleByEvaluatees: 'Visible para evaluados',
    visibleByEvaluateesTooltip: 'Esta opción le permite al Estudiante visualizar el {entity}',
    missingDistributeScore: 'Falta distribuir puntaje en las preguntas de acuerdo al puntaje del {entity}',
    allowAttachFiles: 'Permitir adjuntar archivos',
    allowAttachFilesTooltip: 'Esta opción permite al Estudiante adjuntar archivos para sus {entity}',
    allowReopen: 'Permitir reapertura',
    allowReopenTooltip: 'Esta opción permite al Estudiante reabrir el {entity} mientras esté vigente para modificar lo ya respondido, sin perder sus respuestas previas y respetando las fechas de inicio y término.',
    maxReopenings: 'Cantidad de reaperturas',
    reopenEntity: 'Reabrir {entity}',
    reopenEntityTooltip: 'Le quedan {count} reaperturas disponibles.',
    sureToReopenEntity: '¿Está seguro/a de reabrir el {entity}?',
    reopenKeepsPreviousAnswers: 'Se conservarán sus respuestas previas y podrá modificarlas mientras la evaluación esté vigente.',
    reopenedEntity: 'El {entity} se reabrió correctamente.',
    reopeningsUsed: 'Reaperturas utilizadas',
    lockDescriptorCreation: 'Bloquear creación de {entity}',
    lockDescriptorCreationTooltip: 'Esta opción permite bloquear al perfil del Profesor(a) crear nuevos {entity1} en la vista del {entity2}',
    lockSegmentCreationTooltip: 'Esta opción permite bloquear la creación de {entity} a los Docentes',
    lockQuestionCreation: 'Bloquear creación de preguntas',
    lockQuestionCreationTooltip: 'Esta opción permite bloquear la creación de preguntas a los Docentes',
    allowGroupCreation: 'Permitir creación de {entity}',
    allowGroupCreationTooltip: 'Esta opción permite la creación de {entity}',
    selectAttachments: 'Seleccionar Anexos',
    allowAutoEvaluateTooltip2: 'Esta opción permite al Estudiante auto evaluarse al momento de contestar.',
    cannotDeleteInstrumentClosed: 'No se puede eliminar porque el instrumento está cerrado',
    cannotDeleteStudentEntered: 'No se puede eliminar porque un estudiante ingresó a la prueba o fue calificado',

    // ========== NewInstrumentForm (methods) ==========
    instrumentWeighingZeroTitle: 'El {entity} tiene una ponderación de 0% ¿Está seguro de que desea continuar?',
    instrumentWeighingZeroWarning: 'Este instrumento tiene una ponderación de 0%',
    sureToSaveInstrumentWithGroups: '¿Está seguro de que desea guardar el {entity} siendo que existen <b>Grupos</b> ya creados?',
    actionCannotBeRevertedGroupsDeleted: '¡Esta acción no se podrá revertir y los grupos se eliminarán!',
    instrumentCreated: 'Se creó el {entity}',
    instrumentEdited: 'Se editó el {entity}',
    sureToDeleteInstrument: '¿Está seguro de que desea eliminar el <b>{entity}</b>?',

    // ========== ContainerInstrument ==========
    updateInstrumentInCreatedSections: 'Actualizar el {entity} en las {sections} creadas',
    colorBlueSectionDescription: 'El {instrument} no se encuentra en la {section}, pero la {evaluation} contenedora sí, se creará una copia del actual.',
    colorGreenSectionDescription: 'Se elimina el {instrument} de la {section}, y se reemplaza por una copia del actual.',
    colorOrangeSectionDescription: 'Se mantiene el {instrument} de la {section}, y se agrega una copia del actual.',
    colorRedSectionDescription: 'La {evaluation} contenedora no se encuentra en la {section}, no es posible crear una copia del actual.',
    listOfEntityToNavigate: 'Listado de {entity} para navegar:',
    instrumentsUpdatedInSections: 'Los {entity} fueron actualizados en las siguientes {sections}:',
    deletedAndRecreated: 'Eliminado y Recreado:',
    duplicated: 'Duplicado:',
    recreatedMale: 'Recreado:',
    evaluationWillStartOn: 'La evaluación comenzará el',
    within: 'Dentro de:',
    noPermissionToAnswer: 'Usted no tiene permiso para contestar',
    startEntity: 'Iniciar {entity}',
    finalizeEntity: 'Finalizar {entity}',
    hideEntity: 'Ocultar {entity}',
    printEntity: 'Imprimir {entity}',
    uploadFile: 'Subir Archivo',
    hidePrintScore: 'Ocultar <strong>Puntaje</strong> al Imprimir',
    hidePrintWeighting: 'Ocultar <strong>Ponderación</strong> al Imprimir',
    wantToStartAnswering: '¿Desea comenzar a responder el {entity}?',
    instrumentRequiresConsent: 'La realización de este {entity} debe contar con la autorización o consentimiento por parte del estudiante.',
    begin: 'Comenzar',
    continueAnswering: 'Seguir respondiendo',
    missingQuestionsToAnswer: 'Te faltan por responder las siguientes preguntas:',
    notAttachedFileYet: 'Aún no ha adjuntado ningún archivo.',
    sureToFinalizeEntity: '¿Está seguro/a de que desea <strong>finalizar</strong> el {entity}?',
    answersSubmittedThanks: 'Sus respuestas han sido enviadas satisfactoriamente. Gracias por contestar el {entity}.',
    answersWillBeSubmittedCannotUndo: '¡Sus respuestas serán enviadas y esta acción no se podrá revertir!',
    instrumentFinishedTitle: '¡{entity} finalizado!',
    anotherInstrumentAvailable: 'Tienes otro {entity} disponible para responder: <strong>{title}</strong>. ¿Deseas continuar con él ahora?',
    goToNextInstrument: 'Ir al siguiente {entity}',
    evaluationNotAssignedTitle: 'Esta {entity} no está asignada a tu cuenta',
    evaluationNotAssignedText: 'Puedes revisar las que tienes asignadas desde el inicio.',
}
